<template>
  <a v-if="brand"
    :href="brand.buttonContentUrl"
    class="home-banner"
    :style="{
      backgroundColor: brand && brand.backgroundColour,
    }">
    <div class="image-container">
      <!-- <img src="assets/images/banners/vileda-banner4.png" /> -->
      <img :src="imageUrl" v-if="imageUrl" />
    </div>
    <div class="info-group">
      <div>
        <p :style="{color: brand && brand.text_1_BackgroundColor}">{{ brand && brand.text_1 }}</p>
        <h2 :style="{color: brand && brand.text_2_BackgroundColor}">{{ brand && brand.text_2 }}</h2>
      </div>
      <div class="skew-box-group">
        <span v-if="brand && brand.text_3" class="skew-box"
        :style="{color: brand && brand.text_3_BackgroundColor}">{{ brand && brand.text_3 }}</span>
        <h3 class="sale-off skew-box" :style="{color: brand && brand.text_5_BackgroundColor}">
          <span :style="{
      backgroundColor: brand && brand.backgroundColour,
      color: brand && brand.text_4_BackgroundColor,
    }">{{ brand && brand.text_4 }}</span>
          {{ brand && brand.text_5 }}
        </h3>
      </div>
      <div v-if="brand && brand.buttonText">
        <a
          :href="brand && brand.buttonContentUrl"
          target="_blank"
          class="btn font-weight-bold"
          :style="{
            backgroundColor: brand && brand.buttonBackgroundColour,
             color: brand && brand.buttonTextColor,
          }"
        >
          {{ brand && brand.buttonText }}
        </a>
      </div>
    </div>
</a>
</template>

<script>
import config from '@/config';

export default {
  name: 'HomeBanner',
  computed: {
    imageUrl() {
      return this.brand?.brandImageUrl ? `${config.baseUrl}${this.brand?.brandImageUrl}` : false;
    },
    brand() {
      return this.$store.getters.getHighlightedBrand;
    },
  },
  mounted() {
    this.$store.dispatch('getHighlightedBrand');
  },
};
</script>
<style scoped>
.skew-box{
  transform: skew(0deg, 0deg);
}
</style>
